import axios, { AxiosResponse } from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { IBank } from 'safe'
import { BanksTypes, SET_BANKS } from './actionTypes'

const server = process.env.REACT_APP_SERVER_URL

const setBanks = (banks: IBank[]): BanksTypes => ({
  type: SET_BANKS,
  payload: banks,
})

export const fetchBanks =
  (): ThunkAction<Promise<void>, {}, {}, BanksTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, BanksTypes>): Promise<void> => {
    try {
      const response: AxiosResponse<{
        status: number
        banks: IBank[]
      }> = await axios.get(`${server}/finances/bank`)
      dispatch(setBanks(response.data.banks))
    } catch (e) {
      throw e
    }
  }
